module.exports = __webpack_public_path__ + "img/dRichText.88c1dfba.svg";